import { useIonAlert, useIonToast } from "@ionic/react";
import { alarmOutline, closeCircle, documentOutline, homeOutline, pencilOutline, readerOutline } from "ionicons/icons";
import { useCallback, useEffect, useRef, useState } from "react";
import { withRouter } from "react-router";
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import productionController from "../../../../../barrel/controllers/productionController";
import { useCancelToken } from "../../../../../barrel/hooks/useCancelToken";
import useHxfTranslation from "../../../../../barrel/hooks/useHxfTranslation";
import useLocalStorageHandler from "../../../../../barrel/hooks/useLocalStorageHandler";
import usePrevious from "../../../../../barrel/hooks/usePrevious";
import useProductionProcess from "../../../../../barrel/hooks/useProductionProcess";
import usePunchclock from "../../../../../barrel/hooks/usePunchclock";
import useSyncSettings from "../../../../../barrel/hooks/useSyncSettings";
import ActionManagerService from "../../../../../barrel/services/actionManagerService";
import DatesConversionService from "../../../../../barrel/services/datesConversionService";
import SystemSoundService from "../../../../../barrel/services/systemSoundService";
import LoadingSpinnerImg from "../../../../../components/UIComps/LoadingSpinnerImg/LoadingSpinnerImg";
import { useGlobalState } from "../../../../../GlobalCustomStateManagement/GlobalStateProvider";
import CustomArrowBack from "../../../../CustomElements/CustomArrowBack/CustomArrowBack";
import { dispatchCustomPopupsStore } from "../../../../CustomElements/ProductionUI/CustomPopups/CustomPopupsStore";
import { useActionScreenManagerStore } from "../../../../CustomElements/ProductionUI/ProductionOperationConfirmation/ActionScreensManager/ActionScreenManagerStore";
import ProductionTopInfo from "../../../../CustomElements/ProductionUI/ProductionTopInfo/ProductionTopInfo";
import TimeElapsedLabelV2 from "../../../../CustomElements/TimeElapsedLabelV2/TimeElapsedLabelV2";
import InAppTemplate from "../../../../InAppTemplate/InAppTemplate";
import { IonButton, IonIcon } from "@ionic/react";
import {
  dispatchProductionUIStore,
  useProductionUIStore
} from "../../../ProductionOrders/Standard/store/productionConfirmationUIStore";
import {
  dispatchProductionOrderSelectionStore,
  useProductionOrderSelectionStore
} from "../../../ProductionOrders/Standard/store/productionOrderSelectionStore";
import CornerButton from "./CornerButton/CornerButton";
import styles from "./ProductionProcess.module.scss";
import ViewFilesPopup from "../../../../CustomElements/statePopups/viewFilesPopup/viewFilesPopup";
import HxfSafeHtmlContentRender from "../../../../../components/HxfSafeHtmlContentRender/HxfSafeHtmlContentRender";
import DefineInputsDataPopup from "../../../../CustomElements/statePopups/defineInputsDataPopup/DefineInputsDataPopup";
import operationProductsController from "../../../../../barrel/controllers/operationProductsController";
import useFeedbackService from "../../../../../barrel/hooks/useFeedbackService";
import HxfOverlayLoading from "../../../../CustomElements/HxfOverlayLoading/HxfOverlayLoading";
import HxfNumberFormat from "../../../../../barrel/services/hxfNumberFormat";
/*
export interface ILoadedData {
  isLoaded: boolean;
  isLastOperation: boolean;
  currentOperation: any;
  nextOperation: any;
  productionProduct: any;
  productionOrder: any;
  production:any;
}
*/
function ProductionProcess(props: any) {
  const [present] = useIonAlert();
  const [presentToast] = useIonToast();
  const DISABLE_REMINDER = true; //TODO before enabling, separate into a different setting for the "alert", also fix alert acumulation issue
  const productionProcess = useProductionProcess();
  const localStorage = useLocalStorageHandler();
  const { cancelToken, isCancel } = useCancelToken({
    alias: "ProductionStartStage",
  });
  const {t} = useHxfTranslation();
  const syncSettings = useSyncSettings();
  const punchclock = usePunchclock();
  const timerDispatch = useRef(setTimeout(() => {}, 0));


  const timerReminderPendingExecution = useRef<any>(null);
  const lastTimeReminded = useRef(0);

  const productionId = parseInt(props.match.params.productionId);
  const previousProductionId = usePrevious(productionId);

  const [didMount, setDidMount] = useState(false);
  const [showViewFiles, setShowViewFiles] = useState<any>(null);

  const [productionData, setProductionData] = useState<any>({}); //holds the loaded production data
  const currentProductionUIStoreData = useProductionUIStore();
  const currentProductionOrderSelectionData =  useProductionOrderSelectionStore();
  
  const { appState } = useGlobalState();
  const [showElapsedTimer, setShowElapsedTimer] = useState(false);

  const firstTimeAlert = useRef<any>(null);
  const [triggerRemindAlert, setTriggerRemindAlert] = useState(1);
  const [restartReminder, setRestartReminder] = useState(1);
  const [isOperationDescriptionPopup, setIsOperationDescriptionPopup] = useState<any>(null);
  const {sessionState} = useGlobalState();
  const feedbackService = useFeedbackService();
  const prevRestartReminder = usePrevious(restartReminder);
  const prevCountRemindAlert = usePrevious(triggerRemindAlert);
  const [isLoading, setIsLoading] = useState(false);
  //deprecated
  /*const [productionStepData, setProductionStepData] = useState({
    isLastOperation: false,
    currentOperation: {},
    nextOperation: {},
    productionProduct: {},
    productionOrder: {},
    production:{}
  } as ILoadedData);*/

  const isProductionDataLoaded = () => {
    return (
      "production" in currentProductionOrderSelectionData &&
      "Id" in currentProductionOrderSelectionData.production
    );
  };

  useEffect(() => {
  
    if(prevCountRemindAlert !== triggerRemindAlert && prevCountRemindAlert){
      if(!DISABLE_REMINDER){
        console.log("Triggering remind alert");
        callTriggerRemindAlert();
        initiateTimerReminderPendingExecution();
      }
    }

  }, [triggerRemindAlert]);// eslint-disable-line

  useEffect(() => {
  
    if(prevRestartReminder !== restartReminder && prevRestartReminder){
      if(!DISABLE_REMINDER){
        console.log("Triggering restarting reminder");
        initiateTimerReminderPendingExecution();
      }

    }

  }, [restartReminder]);// eslint-disable-line
  //
  
  const callTriggerRemindAlert = useCallback((argPendingDistributionExecutionReminderData:any = null) => {

    let _pendingDistributionExecutionReminderData = argPendingDistributionExecutionReminderData ? argPendingDistributionExecutionReminderData : currentProductionOrderSelectionData?.currentOperation?._pendingDistributionExecutionReminderData;
   
    if(_pendingDistributionExecutionReminderData){
      console.log("Remind alert triggered!");
      SystemSoundService().alertSound();
      presentToast({
        message: t('reminder') + '! - ' + _pendingDistributionExecutionReminderData.operationProduct_name,
        position:'middle',
        icon:alarmOutline,
        cssClass:'hxfAlertToast',
        buttons:[{
          role:'cancel',
          text:t('understood')
        }],
        color:'warning',
        duration: 3600000});


      //todo, sound alert, show side popup
    }
  },[presentToast,currentProductionOrderSelectionData?.currentOperation?._pendingDistributionExecutionReminderData]); // eslint-disable-line

  const getProperOperationDescriptionHtml = (description:any) => {
    if(!description){
      return "";
    }
    description = description.replace(/\n/g, '<br>');
    return description;
  }
  const initiateTimerReminderPendingExecution = useCallback((curOperationData = null,argOperationDuration = null, productionRecordDateStart = null,argpendingDistributionExecutionReminderData = null) => {
    let reminderSkipFirstExecution = curOperationData?.reminderSkipFirstExecution === 1;

    clearTimeout(timerReminderPendingExecution.current);
    let operationExpectedDuration = argOperationDuration ? argOperationDuration : currentProductionOrderSelectionData?.currentOperation?.expectedDuration;

    let _pendingDistributionExecutionReminderData = argpendingDistributionExecutionReminderData ? argpendingDistributionExecutionReminderData : currentProductionOrderSelectionData?.currentOperation?._pendingDistributionExecutionReminderData;
    


    let prDateStart = productionRecordDateStart ? productionRecordDateStart : currentProductionOrderSelectionData.productionRecord.dateStart;
    let dateStartObj = DatesConversionService().convertedDateObject(prDateStart);
    let currentDate = new Date();

    let timeDiffMs: any = currentDate.getTime() - dateStartObj.getTime();
    let currentTimeElapsed = timeDiffMs / 1000;
   
    let currentTs = Date.now()/1000;
    let extraDelay = 0;

    let pendingOneEveryExecutionsQty = _pendingDistributionExecutionReminderData?.pendingOneEveryExecutionsQty ? _pendingDistributionExecutionReminderData?.pendingOneEveryExecutionsQty : 0;

 
    let remindEveryXSeconds = operationExpectedDuration*pendingOneEveryExecutionsQty;
    if(!reminderSkipFirstExecution && currentTimeElapsed > operationExpectedDuration && !firstTimeAlert.current){
      console.log("Remind triggered on start");
      lastTimeReminded.current = currentTs;

      callTriggerRemindAlert(_pendingDistributionExecutionReminderData);
      extraDelay = 5;
      firstTimeAlert.current = true;
    }

    let nextRemindAt = (remindEveryXSeconds+extraDelay)*1000;
    console.log("next remind in: ", nextRemindAt);
    timerReminderPendingExecution.current = setTimeout(() => {
 
      let currentTs = Date.now()/1000;

      let disableSpamDelayControl = false;

      let timeDiff = currentTs - lastTimeReminded.current;
 
      if(disableSpamDelayControl || timeDiff > 60){
        lastTimeReminded.current = currentTs;
      
        firstTimeAlert.current = true;

        console.log("Remind triggered interval");
        setTriggerRemindAlert(triggerRemindAlert +1);
      }else{
        setTimeout(() => {
          setRestartReminder(restartReminder + 1);
        },1000);
        
      }


    }, nextRemindAt);

    //currentProductionOrderSelectionData?.currentOperation?._pendingDistributionExecutionReminderData
  },[restartReminder,callTriggerRemindAlert,triggerRemindAlert,currentProductionOrderSelectionData.productionRecord?.dateStart,currentProductionOrderSelectionData?.currentOperation?.expectedDuration,currentProductionOrderSelectionData?.currentOperation?._pendingDistributionExecutionReminderData]);

  const loadCurrentProduction = useCallback(() => {
    clearTimeout(timerDispatch.current);

    let currentWorkerCode = localStorage.getWorkerIdentificationCode();
    
    if(appState.isConnectionAvailable()){
      ActionManagerService().resetAllScreensState();
      productionController()
      .getWorkerProduction(currentWorkerCode, productionId, true, cancelToken)
      .then((res) => {
        setShowElapsedTimer(true);

        syncSettings.check(res);
        console.log("Production loaded successfully.");

        let productionResp = res?.data?.response?.data;

        if (!productionResp) {
          throw "unexpected production resp";
        }
        let requiresPunchclockIn =
          res?.data?.response?.data?.extra?.requirePunchclockIn;
        if (requiresPunchclockIn) {
          punchclock.redirRequirePunchclockIn();
          return;
        }
        setProductionData(productionResp);

        let isActive = false;
        let isLastOperation = true;
        let currentOperation: any = null;
        let nextOperation: any = null;
        let productionProduct: any = null;
        let productionOrder = productionResp.productionOrder;

        let productionOrderProduct = null;
        let pops = productionOrder?.productionOrder_productsData;

        let popSpaceDriveFiles = productionResp?.popSpaceDriveFiles;
        let popDefinedChecklistVariableValuesOverride = productionResp?.popDefinedChecklistVariableValuesOverride;
        if(pops){
          for(let i = 0; i<pops.length; i++){
            if(parseInt(pops[i].Id_ProductionOrder_Product ) === productionResp.Id_ProductionOrder_Product){
              productionOrderProduct = pops[i];
              break;
            }
          }
        }
       
        let productionRecord = {
          Id: productionResp.Id,
          ref:productionResp.ref,
          _parentRef:productionResp?._parentRef,
          scaleProductivity: productionResp.scaleProductivity,
          Id_ProductionOrder_Product: productionResp.Id_ProductionOrder_Product,
          dateStart: productionResp.dateStart,
          dateEnd: productionResp.dateEnd,
          isWaitingResume: productionResp.isWaitingResume,
          _elapsedSeconds:productionResp._elapsedSeconds,
          selectedMachines:productionResp?.selectedMachines
        };
        let production = {
          Id: productionResp.Id_Production,
          persistedStateResult: productionResp.production.persistedStateResult,
        };
        let productionOrderProduct_ParameterizedVariableValues = [];
        if (productionResp.productionOrderProduct_ParameterizedVariableValues) {
          productionOrderProduct_ParameterizedVariableValues =
            productionResp.productionOrderProduct_ParameterizedVariableValues;
        }
        if (productionRecord.isWaitingResume) {
          dispatchProductionUIStore({
            type: "SET_TIMER_ELAPSED_ENABLED",
            payload: false,
          });
          dispatchProductionUIStore({
            type: "SET_OPERATION_OVERLAY",
            payload: true,
          });
        } else {
          dispatchProductionUIStore({
            type: "SET_TIMER_ELAPSED_ENABLED",
            payload: true,
          });
          dispatchProductionUIStore({
            type: "SET_OPERATION_OVERLAY",
            payload: false,
          });
        }
        //check if production is still active
        if (productionResp.dateStart == productionResp.dateEnd) {
          isActive = true;
        }

        if (!isActive) {
          console.log("this production record has already been closed");
          props.history.push("/feature/production-orders");
        } else {
          //is active

          //product object
          if (!productionResp.product) {
            //an error occurred
            console.log("Failed to find the production product");
            throw new Error("Failed to find the production product");
          }
          productionProduct = productionResp.product;

          //find the operation we are working on
          for (let i = 0; i < productionResp.product.operations.length; i++) {
            let iterOperation = productionResp.product.operations[i];
            if (iterOperation.Id === productionResp.Id_OperationProduct) {
              currentOperation = productionResp.product.operations[i];
              break;
            }
          }

          if (currentOperation === null) {
            //an error occurred
            console.log(
              "Failed to find the production operation in the product operations"
            );
            throw new Error(
              "Failed to find the production operation in the product operations"
            );
          }

          let idNextOperation = null;

          for (
            let i = 0;
            i < productionResp.product.operationsRelations.length;
            i++
          ) {
            let iterRelation = productionResp.product.operationsRelations[i];
            //check if it is the last operation
            if (iterRelation["Id_OperationProduct"] === currentOperation.Id) {
              isLastOperation = false;
              //get next Operation Id

              idNextOperation = iterRelation["Id_Next_OperationProduct"];
            }
          }

          //find next operation obj
          if (idNextOperation != null) {
            for (let i = 0; i < productionResp.product.operations.length; i++) {
              let iterOperation = productionResp.product.operations[i];
              if (iterOperation.Id === idNextOperation) {
                nextOperation = productionResp.product.operations[i];
                break;
              }
            }
          }

     
          if(currentOperation?._pendingDistributionExecutionReminderData){
           
            initiateTimerReminderPendingExecution(currentOperation,currentOperation.expectedDuration, productionRecord.dateStart, currentOperation?._pendingDistributionExecutionReminderData);
          }
          

          let prTempStore = productionResp?.prTempStore ? productionResp.prTempStore : [];
          //prtempstore proper load

          let cleanArrStoreData = [];
          for(let i = 0; i<prTempStore.length; i++){
           let element = prTempStore[i];
           let preparedData = null;
            try {
              preparedData = JSON.parse(prTempStore[i].data);
            } catch (error) {
              console.error("error in pr temp store parsing..");
            }

            if(preparedData){
              element.data = preparedData;
              cleanArrStoreData.push(element)
            }

          }
          prTempStore = cleanArrStoreData;
          //
          //end of checks
          let stagedMaterial = productionResp?.stagedMaterial;
          
          dispatchProductionOrderSelectionStore({
            type: "SET_STORE",
            payload: {
              isCurrentOperationTheLast: isLastOperation,
              productionOrder: productionOrder,
              productionOrderProduct_ParameterizedVariableValues:productionOrderProduct_ParameterizedVariableValues,
              product: productionProduct,
              currentOperation: currentOperation,
              currentOperationActionIndex: 0,
              nextOperation: nextOperation,
              productionRecord: productionRecord,
              production: production,
              prTempStore:prTempStore,
              productionOrderProduct:productionOrderProduct,
              popSpaceDriveFiles:popSpaceDriveFiles ? popSpaceDriveFiles : [],
              popDefinedChecklistVariableValuesOverride: popDefinedChecklistVariableValuesOverride ? popDefinedChecklistVariableValuesOverride : [],
              stagedMaterial:stagedMaterial
            },
          });
        }
      })
      .catch((res) => {
        if (isCancel(res)) {
          return;
        }

        let errors = res?.response?.data?.issues?.errors;
        console.log(" failed to load production: ", res);
        //error failed
        
        props.history.push("/feature/production-orders");
        

        if(errors && errors.includes("error.po.disabled")){
          feedbackService.notifyToast(t('rel.po.disabled'),'error',{duration:3000});
          return;
        }


        try {
          //deprecate error handling bellow
          let errorRes = res.error.exceptionObj.response;
          if (errorRes.status == 400) {
            if (errorRes.data.response) {
              let errors = errorRes.data.response;
              if (errors.issues) {
                console.log("has errors, handle here");
              }
            }
          }
        } catch (ex) {
          console.log("failed to handle error");
        }
      });
    }
    

  }, [
    localStorage,
    punchclock,
    productionId,
    props,
    cancelToken,
    isCancel,
    syncSettings,
    appState,
    initiateTimerReminderPendingExecution
  ]);


  const getArrayBomWithIrregularitiesToShow = (arrayProductBom:any) => {
    
    let cleanArrayProductBom = [];

    for(let i = 0; i<arrayProductBom.length; i++){
      if(arrayProductBom[i]?._mapsIrregularitiesInfo){
        cleanArrayProductBom.push(arrayProductBom[i]);
      }
    }

    return cleanArrayProductBom;
  }

  const getNormalChecklistRecordPVVValueInvertible = (productComponent:any, checklistRecordPVVData:any) => {

    let currentValue = checklistRecordPVVData?.Value;
    if(checklistRecordPVVData?.checklistParameterizedVariableValueConfig?.invertValueAccordingToIrrProductInvertiblePv === 1){
      //search for the first variable marked as "invertible"
      
      let valueToInvertFrom = null;
      let arrayProductParameterizedVariables= productComponent?.arrayProductParameterizedVariables;
      if(arrayProductParameterizedVariables){
        for(let i = 0; i<arrayProductParameterizedVariables.length; i++){
          if(arrayProductParameterizedVariables[i]?.isInvertibleInspectionValue === 1){
            valueToInvertFrom = arrayProductParameterizedVariables[i]?.Value;
            break;
          }
        }

        let isValidNumber = !isNaN(valueToInvertFrom);
        let isCurrentValidNumber = !isNaN(currentValue);
        if(isCurrentValidNumber && isValidNumber && valueToInvertFrom !== null){
          valueToInvertFrom = parseFloat(valueToInvertFrom); //exemplo Rolo tem 1000 metros, o metro 10 passa a ser o metro 990
          currentValue = parseFloat(currentValue);
          let inverseInspectionValue = currentValue - valueToInvertFrom;
          inverseInspectionValue = inverseInspectionValue*-1;
          return parseFloat(HxfNumberFormat().val(inverseInspectionValue));
        }
      }
    }
    return currentValue;
  }

  const getNormalChecklistRecordPVVValueElement = (checklistRecordPVVData:any) => {
    return (<>{checklistRecordPVVData.Value}</>);
  }
  const getNormalChecklistRecordPVVValueInvertibleElement = (productComponent:any, checklistRecordPVVData:any) => {

    let currentValue = checklistRecordPVVData?.Value;
    if(checklistRecordPVVData?.checklistParameterizedVariableValueConfig?.invertValueAccordingToIrrProductInvertiblePv === 1){
      //search for the first variable marked as "invertible"
      

          return (
            <div className={styles.inversibleComparisonContainer}> <div>{getNormalChecklistRecordPVVValueInvertible(productComponent, checklistRecordPVVData)}</div>  <div className={styles.inversibleIcon}><CompareArrowsIcon/></div> <div className={styles.inversibleOriginalValue}>{currentValue}</div></div>
          )
        
      
    }
    return getNormalChecklistRecordPVVValueElement(checklistRecordPVVData);
  }
  const getProperlyOrderedChecklistRecordIds= (productComponent:any, mapChecklistRecords_filledData:any,mapChecklist_checklistRecordIds:any, checklistId:any) => {
    
    let relevantChecklistRecordIds = mapChecklist_checklistRecordIds[checklistId];

    let orderedChecklistRecordIds = [];

    let ORDER_ASC_FROM_FIRST_NUMERIC_CLR_PVV_VALUE_FOUND = true; //if the behaviour is changed, create a new setting flag
    if(ORDER_ASC_FROM_FIRST_NUMERIC_CLR_PVV_VALUE_FOUND){
      
        let arrayChecklistRecordsMergedPVVs = [];
        for(let i = 0; i<relevantChecklistRecordIds.length; i++){
            let arrayChecklistRecordsFilledPValues = mapChecklistRecords_filledData?.[relevantChecklistRecordIds[i]];
            for(let j = 0; j<arrayChecklistRecordsFilledPValues.length; j++){
              arrayChecklistRecordsMergedPVVs.push(arrayChecklistRecordsFilledPValues[j]);
            }
  
        }
   
        
        if(arrayChecklistRecordsMergedPVVs){
          for(let i = 0; i<arrayChecklistRecordsMergedPVVs.length; i++){
            let originalValue = arrayChecklistRecordsMergedPVVs[i].Value;
            let varType = arrayChecklistRecordsMergedPVVs[i].varType;
            if(varType === "numeric"){
              let relevantValueOrderFrom = originalValue;
              if(arrayChecklistRecordsMergedPVVs[i]?.checklistParameterizedVariableValueConfig?.invertValueAccordingToIrrProductInvertiblePv === 1){
                relevantValueOrderFrom = getNormalChecklistRecordPVVValueInvertible(productComponent, arrayChecklistRecordsMergedPVVs[i]);
              }
              arrayChecklistRecordsMergedPVVs[i]._tempOrderVal = relevantValueOrderFrom; 
            }
          }
        }
  
        let mapAlreadyAddedChecklistRecordId:any = {};
    
        arrayChecklistRecordsMergedPVVs = arrayChecklistRecordsMergedPVVs.sort((a:any, b:any) => a._tempOrderVal - b._tempOrderVal);
        //for each first match checklist record, show as first
        for(let i = 0; i<arrayChecklistRecordsMergedPVVs.length; i++){
          let idChecklistRecord = arrayChecklistRecordsMergedPVVs[i].Id_ChecklistRecord;
          if(!mapAlreadyAddedChecklistRecordId?.[idChecklistRecord]){
            orderedChecklistRecordIds.push(idChecklistRecord);
          }
         
        }
      
    }else{
      return relevantChecklistRecordIds;
    }

    return orderedChecklistRecordIds;
  }

  const getIrregularitiesShowElement = (productComponent:any,index:any) => {
        
        let mapsIrregularitiesInfo = productComponent?._mapsIrregularitiesInfo;

        let mapProduct_Irregularity_Checklist_ChecklistRecord_FilledData= mapsIrregularitiesInfo?.mapProduct_Irregularity_Checklist_ChecklistRecord_FilledData;
        let hasData = mapProduct_Irregularity_Checklist_ChecklistRecord_FilledData && Object.keys(mapProduct_Irregularity_Checklist_ChecklistRecord_FilledData).length > 0;
        if(!hasData){
          return (<></>)
        }
        let mapIrregularitiesData= mapsIrregularitiesInfo?.mapIrregularitiesData;
        let mapIrrChecklistData= productComponent?.mapIrrChecklistData;
        let mapAlreadyAddedIrr:any = {};
        let mapAlreadyAddedCr:any = {};
        let relevantIrregularityIds = [];
        let relevantChecklistIds:any = [];
        let relevantChecklistRecordIds = [];
        let mapChecklist_checklistRecordIds:any = [];
        let mapChecklistRecords_filledData:any = {};
        let mappedProductKeys = Object.keys(mapsIrregularitiesInfo?.mapProduct_Irregularity_Checklist_ChecklistRecord_FilledData);
        let mappedProductKey = mappedProductKeys[0];
        if(mapProduct_Irregularity_Checklist_ChecklistRecord_FilledData?.[mappedProductKey]){
            let irregularityIds = Object.keys(mapProduct_Irregularity_Checklist_ChecklistRecord_FilledData[mappedProductKey]);
            for(let i = 0; i<irregularityIds.length; i++){
                //check if irregularities have checklists that have checklist records filled data
                let checklistIds = Object.keys(mapProduct_Irregularity_Checklist_ChecklistRecord_FilledData[mappedProductKey][irregularityIds[i]]);
                for(let j = 0; j<checklistIds.length; j++){
                    let checklistRecordIds = Object.keys(mapProduct_Irregularity_Checklist_ChecklistRecord_FilledData[mappedProductKey][irregularityIds[i]][checklistIds[j]]);
                    for(let k = 0; k<checklistRecordIds.length; k++){
                        let filledData = mapProduct_Irregularity_Checklist_ChecklistRecord_FilledData[mappedProductKey][irregularityIds[i]][checklistIds[j]][checklistRecordIds[k]];
                        if(filledData.length > 0){
                            if(!mapAlreadyAddedIrr?.[irregularityIds[i]]){
                                relevantIrregularityIds.push(irregularityIds[i]);
                                mapAlreadyAddedIrr[irregularityIds[i]] = true;
                            }
                            if(!mapAlreadyAddedCr?.[checklistIds[j]]){
                                relevantChecklistIds.push(checklistIds[j]);
                                mapAlreadyAddedCr[checklistIds[j]] = true;
                            }
                            
                            relevantChecklistRecordIds.push(checklistRecordIds[k]);
                        }

                        mapChecklistRecords_filledData[checklistRecordIds[k]] = filledData;
                    }
                    mapChecklist_checklistRecordIds[checklistIds[j]] = checklistRecordIds;
                }
            }
        }
            
       
   
    return (<div className={styles.bomIrregularitiesSection}>
            {relevantIrregularityIds && relevantIrregularityIds.length > 0 && (
                <div style={{marginTop:10}}>
   
                    <div style={{textAlign:'center'}}><b>{t('irregularities')}</b></div>
                {relevantIrregularityIds.map((irrId:any,idxIrr:any) => (
                    <div key={"productstockres_" + index + "_" + idxIrr} className={styles.bomIrrContainer}>
                        <div className={styles.irregularityLabelContainer}><ThumbDownAltIcon/> {mapIrregularitiesData?.[irrId]?.name}</div>
                        
                        {relevantChecklistIds.map((checklistId:any,idxChecklist:any) => (
                            <div key={"productstockreschk_" + index + "_" + idxIrr + "_" + idxChecklist} className={styles.checklistContent}>
                                <div>
                                  <div>{t('checklist')}</div>
                                    <div>{mapIrrChecklistData?.[parseInt(checklistId)]?.name}</div>

                                    {getProperlyOrderedChecklistRecordIds(productComponent,mapChecklistRecords_filledData,mapChecklist_checklistRecordIds,checklistId).map((checklistRecordId:any, idxChecklistRecord:any) => (
                                        <div key={"productstockreschkcr_" + index + "_" + idxIrr + "_" + idxChecklist + "_" + idxChecklistRecord}>
                                            {mapChecklistRecords_filledData[checklistRecordId].map((checklistRecordPVVData:any, idxChecklistRecordPVV:any) => (
                                                <div key={"crfd_" + index + "_" + idxIrr + "_" + idxChecklist + "_" + idxChecklistRecord + "_" + idxChecklistRecordPVV}>
                                                
                                                    <b>{checklistRecordPVVData.name}:</b> {checklistRecordPVVData?.checklistParameterizedVariableValueConfig?.invertValueAccordingToIrrProductInvertiblePv === 1 ? (
                                                      <>
                                                      {getNormalChecklistRecordPVVValueInvertibleElement(productComponent,checklistRecordPVVData)}
                                                      </>
                                                    ) : (
                                                      <>
                                                      {getNormalChecklistRecordPVVValueElement(checklistRecordPVVData)}
                                                      </>
                                                    )} 
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                ))}
                </div>
            )}
    </div>)
  }
  const hasBomIrregularitiesToShow = (arrayProductBom:any) => {
    
    if(!arrayProductBom){
      return false;
    }

    
    for(let i = 0; i<arrayProductBom.length; i++){
      if(arrayProductBom[i]?._mapsIrregularitiesInfo){
        return true;
      }
    }

    return false;
  }

  const getInformationContainer = () => {

    let informationObject:any = {};

    //we only show the information container if it has "relevant info to show"
    if(currentProductionOrderSelectionData?.productionRecord?.selectedMachines && currentProductionOrderSelectionData?.productionRecord?.selectedMachines.length > 0){
      informationObject = {...informationObject, machineName:currentProductionOrderSelectionData?.productionRecord?.selectedMachines[0]?.machineName};
    }

    if(currentProductionOrderSelectionData?.productionRecord?.ref && currentProductionOrderSelectionData?.productionRecord?.ref !== ""){
      informationObject = {...informationObject, ref:currentProductionOrderSelectionData?.productionRecord?.ref };
    }
    
    if(currentProductionOrderSelectionData?.productionRecord?._parentRef && currentProductionOrderSelectionData?.productionRecord?._parentRef !== ""){
      informationObject = {...informationObject, _parentRef:currentProductionOrderSelectionData?.productionRecord?._parentRef };
    }

    if(currentProductionOrderSelectionData?.productionOrderProduct?.description && currentProductionOrderSelectionData?.productionOrderProduct?.description !== ""){
      informationObject = {...informationObject, popDescription:currentProductionOrderSelectionData?.productionOrderProduct?.description };
    }
    
    

    let spaceDriveFiles = currentProductionOrderSelectionData?.currentOperation?._spaceDriveFiles;

    if(spaceDriveFiles){
      informationObject = {...informationObject, spaceDriveFiles:spaceDriveFiles };
    }

    let popSpaceDriveFiles = currentProductionOrderSelectionData?.popSpaceDriveFiles;
    if(popSpaceDriveFiles){
      informationObject = {...informationObject, popSpaceDriveFiles:popSpaceDriveFiles};
    }

    informationObject = {...informationObject, arrayProductBom: currentProductionOrderSelectionData?.product?.arrayProductBom};


    let popPVVS = currentProductionOrderSelectionData?.productionOrderProduct_ParameterizedVariableValues;
    if(popPVVS){
      informationObject = {...informationObject, popPVVS: popPVVS};
    }

    let hasPopSfsDriveToShow = (informationObject?.spaceDriveFiles && informationObject?.spaceDriveFiles.length > 0) || (informationObject?.popSpaceDriveFiles && informationObject?.popSpaceDriveFiles.length > 0);

    //check if informationObject has relevant info
    let infoObjKeys:any = Object.keys(informationObject);
    
    if(infoObjKeys.length === 0){
      return (<></>)
    }

    let totalShowInformationKeys = infoObjKeys.length;
    
    for(let i = 0; i<infoObjKeys.length; i++){

      //specific key checks to avoid showing empty information
      if(infoObjKeys[i] === "popSpaceDriveFiles"){
        if(!hasPopSfsDriveToShow){
          totalShowInformationKeys--;
        }
      }

      if(infoObjKeys[i] === "popPVVS"){
        if(informationObject?.popPVVS.length <= 0){
          totalShowInformationKeys--;
        }
      }

      if(infoObjKeys[i] === "arrayProductBom"){
        if(informationObject?.arrayProductBom?.length <= 0){
          totalShowInformationKeys--;
        }else{
          //which conditions are used based on array prduct bom info
          if(!hasBomIrregularitiesToShow(informationObject?.arrayProductBom)){
            totalShowInformationKeys--;
          }else{
            let totalBomIrregularities = getArrayBomWithIrregularitiesToShow(informationObject?.arrayProductBom);
            if(totalBomIrregularities.length <= 0){
              totalShowInformationKeys--;
            }
          }
          
        }
      }
    }

    if(totalShowInformationKeys <= 0){
      return (<></>)
    }
    return (
      <div className={styles.productionStartPreviewContainer}>
      <div className={styles.elemElement} style={{backgroundColor:'#cae7ff70'}}>
        <div style={{textAlign:'center',margin:9}}>
          <div>
            <b>{t('information')}</b>
          </div>{" "}
        </div>
        <div className={styles.separator}></div>
        
        {informationObject?.popDescription && (
                  <div className={styles.operationDescription}>
                  <div>
            
                    
                        <div className={styles.popDescriptionTitle}>
                            <b>{t('description')}</b>
                        </div>
                        <div>
                          <HxfSafeHtmlContentRender>
                            {informationObject?.popDescription}
                          </HxfSafeHtmlContentRender>
                        </div>
            
                
                  </div>
        
                </div>
        )}
        <div className={styles.operationDescription}>
          <div>
          {informationObject?._parentRef && (
            <>
            
                <div className={styles.infoSection}>
                    <b>{t('parent.ref')}:</b> {informationObject._parentRef}
                </div>
            
            </>
          )}
          {(informationObject?.ref && !informationObject?._parentRef) && (
          <div className={styles.infoSection}>
              <b>{t('ref')}:</b> {informationObject.ref}
          </div>
          )}

          {informationObject.machineName && (
            <div className={styles.infoSection}>
                  <b>{t('machine')}:</b> {informationObject.machineName}
            </div>
          )}

          {informationObject?.popPVVS && informationObject?.popPVVS.length > 0 && (
              <div className={styles.infoSection}>
                   <div> <b>{t('parameterized.variables.short')}</b></div>
                   <div style={{fontSize:13,maxWidth:272}}>
                   {informationObject?.popPVVS.map((objPVV:any, index:any) => (
                      <span key={"info_pvv_" + index}>{index !== 0 ? ", " :""}<b>{objPVV.name}</b>: {objPVV.Value}</span>
                    ))}
                   </div>
              </div>
          )}
          </div>

        </div>

      
        {(hasPopSfsDriveToShow) && (
          <div>
            <div className={`${styles.widthAndCenter} ${styles.viewFilesTitle}`}>{t('view.files')}</div>
            {informationObject?.spaceDriveFiles && informationObject?.spaceDriveFiles.length > 0 && (
            <div>
              
              <div className={styles.widthAndCenter}>
                  <IonButton
                      className={styles.viewFilesBtn}
                      size={'default'}
                      onClick={() => {
                          setShowViewFiles(spaceDriveFiles);
                      }}
                  >
                      <IonIcon style={{marginRight:5}} slot="icon-only" icon={readerOutline} size={"small"}></IonIcon>
                      {t('operation')}
                      
                  </IonButton>
                  
              </div>
            </div>
          )}

          {informationObject?.popSpaceDriveFiles && informationObject?.popSpaceDriveFiles.length > 0 && (
              <>
              
                <div className={styles.widthAndCenter}>
                    <IonButton
                        className={styles.viewFilesBtn}
                        size={'default'}
                        onClick={() => {
                          setShowViewFiles(popSpaceDriveFiles);
                        }}
                    >
                        <IonIcon style={{marginRight:5}} slot="icon-only" icon={readerOutline} size={"small"}></IonIcon>
                        {t('pop.view.files')}
                    </IonButton>
                </div>
              </>
            )}

          </div>
        )}
        

        {hasBomIrregularitiesToShow(informationObject?.arrayProductBom) && (
              <div>
                {getArrayBomWithIrregularitiesToShow(informationObject?.arrayProductBom).map((objProductComponent:any, index:any) => (
                  <div key={"arrBomWithIrr_" + index}>
                    {getIrregularitiesShowElement(objProductComponent,index)}
                  </div>
                ))}
              </div>
            )}
      </div>
    </div>
    )
  }


  const isZeroDotSomething = () => {

    let distributionEvery = parseInt(currentProductionOrderSelectionData?.currentOperation?._pendingDistributionExecutionReminderData?.pendingOneEveryExecutionsQty);

    if(distributionEvery === 0){
      return true;
    }

    return false;
  }

  useEffect(() => {
    if (!didMount) {
      //triggers on load
      loadCurrentProduction();
      setDidMount(true);
    }

    () => {
      console.log("umounting process");
      clearTimeout(timerDispatch.current);
      if(timerReminderPendingExecution?.current){
        clearTimeout(timerReminderPendingExecution.current);
      }
     
    };
  }, [didMount, loadCurrentProduction]);

  useEffect(() => {
    if (
      previousProductionId !== undefined &&
      previousProductionId !== productionId
    ) {
      //triggers on "NEXT"
      //console.log("CHANGED FROM: " + previousProductionId + " to " + productionId);
      loadCurrentProduction();
    }
  }, [productionId, previousProductionId, loadCurrentProduction]);

  if (!isProductionDataLoaded()) {
    return (
      <InAppTemplate>
        <ProductionTopInfo
          productionOrder={currentProductionOrderSelectionData.productionOrder}
          product={currentProductionOrderSelectionData.productionProduct}
          currentOperation={
            currentProductionOrderSelectionData.currentOperation
          }
          nextOperation={currentProductionOrderSelectionData.nextOperation}
        />
        <CustomArrowBack pushUrl="/feature/production-orders" />
        <LoadingSpinnerImg />
      </InAppTemplate>
    );
  }

  console.log(
    "current production order selection data:",
    currentProductionOrderSelectionData
  );
  return (
    <InAppTemplate>
      <>
      {isLoading && (
        <HxfOverlayLoading/>
      )}
      {isOperationDescriptionPopup && (
        <DefineInputsDataPopup
          onClose={() => {
            setIsOperationDescriptionPopup(false);
          }}
     
          title={t('define.description')}
          mapValuesErrors={[]}
          arrayInputs={[
            {
              label:t('description'),
              inputType:"TEXTFIELD",
              defaultValue:currentProductionOrderSelectionData.currentOperation.description,
              typeInputTextMaxLength:255,
              typeInputTextAutoFocus:true,
              typeTextInputMultiline:true
            }
          ]}
          arrayConfirmationButtons={[
            {
              label:t('confirm'),
              labelStyles:{
                fontSize:25,
                margin:20
              },
              btnStyles:{
                minHeight:80,
                display:'flex',
                justifyContent:'center'
              },
              onClick: (data:any) => {
                setIsOperationDescriptionPopup(null);
                let newDescription = data?.mapInputsValues?.[0];
                operationProductsController().modifyDescription({Id_OperationProduct:currentProductionOrderSelectionData.currentOperation.Id, newDescription:newDescription}).then((res) => {
                  if(!res?.data?.done){
                    throw "unexpected";
                  }
                  let updatedStore = {...currentProductionOrderSelectionData};
                  updatedStore.currentOperation.description = newDescription;
                  dispatchProductionOrderSelectionStore({
                    type:"SET_STORE",
                    payload:JSON.parse(JSON.stringify(updatedStore))
                  });
                  feedbackService.notifyToast(t('saved.successfully'),"success");
                 
                }).catch((res) => {
                  feedbackService.notifyToast(t('error.unexpected'), "error");
                });
                /*
                let newDescription = data?.mapInputsValues?.[0];
                setInfoOrderData({...infoOrderData, description: newDescription})
                setModifiedDescription(true);
                setIsOperationDescriptionPopup(false);*/
              }
            }
          ]}
        />
        )}
        {showViewFiles && (
          <ViewFilesPopup Id_OperationProduct={currentProductionOrderSelectionData.currentOperation.Id} files={showViewFiles} onClosePopup={() => {
            setShowViewFiles(null);
          }}/>
        )}
       
        <ProductionTopInfo
          productionOrder={currentProductionOrderSelectionData.productionOrder}
          product={currentProductionOrderSelectionData.productionProduct}
          currentOperation={
            currentProductionOrderSelectionData.currentOperation
          }
          nextOperation={currentProductionOrderSelectionData.nextOperation}
        />

        {currentProductionUIStoreData.showOperationOverlay && (
          <div className={styles.overlayContainer}></div>
        )}

        <div className={styles.topPageContainer}>
          <div></div>
          <div className={styles.pageTitle}>{t("operation")}</div>
          <div style={{position:'absolute',right:0}}>
            <div className={styles.cornerButtons}>
              <CornerButton
                label={t("home")}
                onClick={() => {
                  present({
                    cssClass: "my-css",
                    header: t("minimize"),
                    message: t("minimize.production.confirm"),
                    buttons: [
                      t("cancel"),
                      {
                        text: t('yes'),
                        handler: (d) => {
                          setShowElapsedTimer(false);
                          dispatchProductionUIStore({
                            type: "SET_ELAPSED_ENABLED",
                            payload: false,
                          });
                   
                          let shopfloorSetting_redirection = currentProductionOrderSelectionData?.currentOperation?.shopfloorSetting_redirection;
                          let idPo = currentProductionOrderSelectionData.productionOrder.Id;
                          let idPop = productionData.Id_ProductionOrder_Product;
                          
                          let redir = null;
                          if(shopfloorSetting_redirection === "REDIR_OPERATION_SELECTION"){
                      
                            redir = "/feature/production-order/" + currentProductionOrderSelectionData.productionOrder.Id + "/po-product/" +currentProductionOrderSelectionData.productionRecord.Id_ProductionOrder_Product;
                          }else if(shopfloorSetting_redirection === "REDIR_PRODUCTION_ORDER_SELECTION"){
                            redir = "/feature/production-orders";
                          }else if(shopfloorSetting_redirection === "REDIR_POP_SELECTION"){
                            redir = "/feature/production-order/" + currentProductionOrderSelectionData.productionOrder.Id;
                          }

                          if(redir){
                            props.history.push(redir);
                          }else{
                            props.history.push("/feature/production-order/" + idPo + "/po-product/" + idPop);
                          }

                         
                        },
                      },
                    ],
                    onDidDismiss: (e) => {},
                  });
                }}
                iconPassed={homeOutline}
              />
              <CornerButton
                onClick={() => {
                  present({
                    cssClass: "my-css",
                    header: t("production.cancellation"),
                    message: t("production.cancel.confirm"),
                    buttons: [
                      t("cancel"),
                      {
                        text: t("yes"),
                        handler: (d) => {
                  
                          let allowOperationPrCollab = currentProductionOrderSelectionData.currentOperation.allowOperationPrCollab === 1 ? true : false;
                          if(allowOperationPrCollab){

                            dispatchCustomPopupsStore({
                              type: "SHOW_COLLAB_CANCEL_POPUP",
                            });
                            
                          }else{
                            setShowElapsedTimer(false);
                            dispatchProductionUIStore({
                              type: "SET_ELAPSED_ENABLED",
                              payload: false,
                            });
                    
                            productionProcess.cancelRecord();
                          }
 
                        },
                      },
                    ],
                    onDidDismiss: (e) => {},
                  });
                }}
                btnType={"danger"}
                label={t("null.record")}
                iconPassed={closeCircle}
              />
            </div>
          </div>

        </div>
        <div style={{display:'flex',flexWrap:'wrap',width:'100%',justifyContent:'center',marginTop:25}} data-self-production-record-id={currentProductionOrderSelectionData?.productionRecord?.Id}>
          {getInformationContainer()}
          
          <div className={styles.productionStartPreviewContainer}>
            <div className={styles.elemElement}>
              <div className={styles.elemTitle}>
                <div style={{marginRight:15}}>
                  ({currentProductionOrderSelectionData.currentOperation.code}){" "}
                  {currentProductionOrderSelectionData.currentOperation.name}
                </div>{" "}
                <div style={{marginLeft:15}}>
                  {" "}
                  {showElapsedTimer && (
                    <div className={styles.operationTakingTime}>
                      <TimeElapsedLabelV2 timerEnabled={currentProductionUIStoreData.timerElapsedEnabled} startFromSeconds={currentProductionOrderSelectionData.productionRecord._elapsedSeconds}/>

                    </div>
                  )}
                </div>
              </div>
              <div className={styles.separator}></div>

              <div className={styles.operationDescription}>
                <div>
                  <div>
                    <HxfSafeHtmlContentRender>
                    {getProperOperationDescriptionHtml(currentProductionOrderSelectionData.currentOperation.description)}
                    </HxfSafeHtmlContentRender>
                  
                  {sessionState.userSessionData.allowOperationDescriptionEdit === 1 && (
                    <div>
                        <IonButton
                          disabled={false}
                          className={styles.modifyLocationBtn}
                          onClick={() => {
                            setIsOperationDescriptionPopup(true);
                          }}
                        >
                          <IonIcon slot="start" size="large" icon={pencilOutline} />
                          {currentProductionOrderSelectionData?.currentOperation?.description ? t("description.modify") : t("define.description")}
                        </IonButton>
                    </div>
                  )}
                  </div>
                  
                  {currentProductionOrderSelectionData?.currentOperation?._pendingDistributionExecutionReminderData &&(
                    <div className={styles.pdeReminderDataInfo}>
                      <div>{t('execute')} <b>1</b> {t('operation.lower')} <b>{currentProductionOrderSelectionData?.currentOperation?._pendingDistributionExecutionReminderData?.operationProduct_name}</b> {isZeroDotSomething() ? (<></>) : (<>{t('at.every')} <b>{parseInt(currentProductionOrderSelectionData?.currentOperation?._pendingDistributionExecutionReminderData?.pendingOneEveryExecutionsQty)}</b> {t('operations.of.type')} <b>{currentProductionOrderSelectionData.currentOperation.name}</b> </>)}  </div>
                    </div>
                  )}
                </div>
            

              </div>
            </div>
          </div>

        </div>
      </>
    </InAppTemplate>
  );
}
export default withRouter(ProductionProcess);
